export default "/static/334da737f892b360c0f8a4994f29cfcf844caefd/frontend/da679ea2bc45412fd43089fd524a5e8e.svg";